@file:OptIn(InternalResourceApi::class)

package lexisoup.core.ui.strings.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/lexisoup.core.ui.strings.generated.resources/"

@delegate:ResourceContentHash(1_078_151_805)
public val Res.string.general_action_cancel: StringResource by lazy {
      StringResource("string:general_action_cancel", "general_action_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 10, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 37),
      ))
    }

@delegate:ResourceContentHash(-1_869_837_839)
public val Res.string.general_action_collapse: StringResource by lazy {
      StringResource("string:general_action_collapse", "general_action_collapse", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 52, 47),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 64, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48, 43),
      ))
    }

@delegate:ResourceContentHash(1_251_668_586)
public val Res.string.general_action_copy: StringResource by lazy {
      StringResource("string:general_action_copy", "general_action_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100, 39),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 120, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92, 35),
      ))
    }

@delegate:ResourceContentHash(72_347_034)
public val Res.string.general_action_download: StringResource by lazy {
      StringResource("string:general_action_download", "general_action_download", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140, 51),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 176, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128, 43),
      ))
    }

@delegate:ResourceContentHash(-1_976_978_125)
public val Res.string.general_action_expand: StringResource by lazy {
      StringResource("string:general_action_expand", "general_action_expand", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 192, 45),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 228, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172, 37),
      ))
    }

@delegate:ResourceContentHash(603_707_330)
public val Res.string.general_action_search: StringResource by lazy {
      StringResource("string:general_action_search", "general_action_search", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 238, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 286, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210, 37),
      ))
    }

@delegate:ResourceContentHash(-1_671_099_932)
public val Res.string.general_cd_translate: StringResource by lazy {
      StringResource("string:general_cd_translate", "general_cd_translate", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 276, 44),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 332, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248, 40),
      ))
    }

@delegate:ResourceContentHash(571_493_625)
public val Res.string.general_copied_to_clipboard: StringResource by lazy {
      StringResource("string:general_copied_to_clipboard", "general_copied_to_clipboard", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 321, 47),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 385, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289, 63),
      ))
    }

@delegate:ResourceContentHash(1_297_545_114)
public val Res.string.general_data_source_chatgpt: StringResource by lazy {
      StringResource("string:general_data_source_chatgpt", "general_data_source_chatgpt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 369, 47),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 453, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353, 47),
      ))
    }

@delegate:ResourceContentHash(-1_649_654_189)
public val Res.string.general_data_source_deepl: StringResource by lazy {
      StringResource("string:general_data_source_deepl", "general_data_source_deepl", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 417, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 501, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 401, 41),
      ))
    }

@delegate:ResourceContentHash(567_846_118)
public val Res.string.general_data_source_kaikki: StringResource by lazy {
      StringResource("string:general_data_source_kaikki", "general_data_source_kaikki", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 459, 62),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 543, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 443, 62),
      ))
    }

@delegate:ResourceContentHash(2_115_135_606)
public val Res.string.general_data_source_mlkit: StringResource by lazy {
      StringResource("string:general_data_source_mlkit", "general_data_source_mlkit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 522, 53),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 606, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 506, 53),
      ))
    }

@delegate:ResourceContentHash(1_489_141_906)
public val Res.string.general_data_source_panlex: StringResource by lazy {
      StringResource("string:general_data_source_panlex", "general_data_source_panlex", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 576, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 660, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 560, 42),
      ))
    }

@delegate:ResourceContentHash(914_605_942)
public val Res.string.general_data_source_tatoeba: StringResource by lazy {
      StringResource("string:general_data_source_tatoeba", "general_data_source_tatoeba", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 619, 47),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 703, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 603, 47),
      ))
    }

@delegate:ResourceContentHash(-175_698_323)
public val Res.string.general_data_source_wortschatz_leipzig: StringResource by lazy {
      StringResource("string:general_data_source_wortschatz_leipzig", "general_data_source_wortschatz_leipzig", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 667, 70),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 751, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 651, 70),
      ))
    }

@delegate:ResourceContentHash(1_791_029_301)
public val Res.string.general_data_source_youglish: StringResource by lazy {
      StringResource("string:general_data_source_youglish", "general_data_source_youglish", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 722, 48),
      ))
    }

@delegate:ResourceContentHash(1_859_714_246)
public val Res.string.general_lang_de: StringResource by lazy {
      StringResource("string:general_lang_de", "general_lang_de", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 738, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 822, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 771, 31),
      ))
    }

@delegate:ResourceContentHash(1_909_240_275)
public val Res.string.general_lang_en: StringResource by lazy {
      StringResource("string:general_lang_en", "general_lang_en", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 774, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 870, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 803, 35),
      ))
    }

@delegate:ResourceContentHash(-1_336_489_025)
public val Res.string.general_lang_fr: StringResource by lazy {
      StringResource("string:general_lang_fr", "general_lang_fr", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 810, 39),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 922, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 839, 31),
      ))
    }

@delegate:ResourceContentHash(-677_998_256)
public val Res.string.general_lang_ru: StringResource by lazy {
      StringResource("string:general_lang_ru", "general_lang_ru", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 850, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 978, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 871, 35),
      ))
    }

@delegate:ResourceContentHash(137_601_319)
public val Res.string.general_lexical_item_detail_type_etymology: StringResource by lazy {
      StringResource("string:general_lexical_item_detail_type_etymology", "general_lexical_item_detail_type_etymology", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 886, 62),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1022, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 907, 58),
      ))
    }

@delegate:ResourceContentHash(1_373_245_417)
public val Res.string.general_lexical_item_detail_type_example: StringResource by lazy {
      StringResource("string:general_lexical_item_detail_type_example", "general_lexical_item_detail_type_example", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 949, 60),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1109, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 966, 60),
      ))
    }

@delegate:ResourceContentHash(-1_298_368_837)
public val Res.string.general_lexical_item_detail_type_explanation: StringResource by lazy {
      StringResource("string:general_lexical_item_detail_type_explanation", "general_lexical_item_detail_type_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1010, 68),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1174, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1027, 68),
      ))
    }

@delegate:ResourceContentHash(-1_239_812_066)
public val Res.string.general_lexical_item_detail_type_forms: StringResource by lazy {
      StringResource("string:general_lexical_item_detail_type_forms", "general_lexical_item_detail_type_forms", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1079, 54),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1255, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1096, 54),
      ))
    }

@delegate:ResourceContentHash(1_629_587_268)
public val Res.string.general_lexical_item_detail_type_pronunciation: StringResource by lazy {
      StringResource("string:general_lexical_item_detail_type_pronunciation", "general_lexical_item_detail_type_pronunciation", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1134, 70),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1318, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1151, 74),
      ))
    }

@delegate:ResourceContentHash(-1_290_614_169)
public val Res.string.general_lexical_item_detail_type_synonyms: StringResource by lazy {
      StringResource("string:general_lexical_item_detail_type_synonyms", "general_lexical_item_detail_type_synonyms", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1205, 61),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1405, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1226, 61),
      ))
    }

@delegate:ResourceContentHash(-2_022_892_648)
public val Res.string.general_lexical_item_detail_type_word_translations: StringResource by lazy {
      StringResource("string:general_lexical_item_detail_type_word_translations", "general_lexical_item_detail_type_word_translations", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1267, 78),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1479, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1288, 74),
      ))
    }

@delegate:ResourceContentHash(238_728_180)
public val Res.string.general_pos_adj: StringResource by lazy {
      StringResource("string:general_pos_adj", "general_pos_adj", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1346, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1562, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1363, 35),
      ))
    }

@delegate:ResourceContentHash(376_132_947)
public val Res.string.general_pos_adv: StringResource by lazy {
      StringResource("string:general_pos_adv", "general_pos_adv", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1382, 31),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1626, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1399, 31),
      ))
    }

@delegate:ResourceContentHash(-1_290_655_393)
public val Res.string.general_pos_article: StringResource by lazy {
      StringResource("string:general_pos_article", "general_pos_article", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1414, 39),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1670, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1431, 39),
      ))
    }

@delegate:ResourceContentHash(265_861_556)
public val Res.string.general_pos_conj: StringResource by lazy {
      StringResource("string:general_pos_conj", "general_pos_conj", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1454, 40),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1718, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1471, 40),
      ))
    }

@delegate:ResourceContentHash(1_050_166_128)
public val Res.string.general_pos_det: StringResource by lazy {
      StringResource("string:general_pos_det", "general_pos_det", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1495, 39),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1755, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1512, 39),
      ))
    }

@delegate:ResourceContentHash(343_316_064)
public val Res.string.general_pos_inj: StringResource by lazy {
      StringResource("string:general_pos_inj", "general_pos_inj", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1535, 39),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1811, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1552, 39),
      ))
    }

@delegate:ResourceContentHash(1_423_457_434)
public val Res.string.general_pos_noun: StringResource by lazy {
      StringResource("string:general_pos_noun", "general_pos_noun", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1575, 40),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1863, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1592, 32),
      ))
    }

@delegate:ResourceContentHash(233_610_669)
public val Res.string.general_pos_num: StringResource by lazy {
      StringResource("string:general_pos_num", "general_pos_num", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1616, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1928, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1625, 35),
      ))
    }

@delegate:ResourceContentHash(-352_270_771)
public val Res.string.general_pos_particle: StringResource by lazy {
      StringResource("string:general_pos_particle", "general_pos_particle", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1652, 40),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1984, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1661, 40),
      ))
    }

@delegate:ResourceContentHash(-161_194_159)
public val Res.string.general_pos_prep: StringResource by lazy {
      StringResource("string:general_pos_prep", "general_pos_prep", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1693, 40),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2033, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1702, 40),
      ))
    }

@delegate:ResourceContentHash(-1_784_523_856)
public val Res.string.general_pos_pron: StringResource by lazy {
      StringResource("string:general_pos_pron", "general_pos_pron", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1734, 36),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2078, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1743, 36),
      ))
    }

@delegate:ResourceContentHash(123_718_014)
public val Res.string.general_pos_verb: StringResource by lazy {
      StringResource("string:general_pos_verb", "general_pos_verb", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1771, 32),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2135, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1780, 32),
      ))
    }

@delegate:ResourceContentHash(2_100_413_905)
public val Res.string.general_translated_by_postfix: StringResource by lazy {
      StringResource("string:general_translated_by_postfix", "general_translated_by_postfix", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1804, 61),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2176, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1813, 57),
      ))
    }

@delegate:ResourceContentHash(835_975_906)
public val Res.string.home_btn_search: StringResource by lazy {
      StringResource("string:home_btn_search", "home_btn_search", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1866, 31),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2238, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1871, 31),
      ))
    }

@delegate:ResourceContentHash(-1_846_276_862)
public val Res.string.home_cd_clear_search_query: StringResource by lazy {
      StringResource("string:home_cd_clear_search_query", "home_cd_clear_search_query", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1898, 62),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2278, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1903, 58),
      ))
    }

@delegate:ResourceContentHash(-2_116_370_657)
public val Res.string.home_cd_settings: StringResource by lazy {
      StringResource("string:home_cd_settings", "home_cd_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1961, 44),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2377, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1962, 36),
      ))
    }

@delegate:ResourceContentHash(-381_071_210)
public val Res.string.home_cd_switch_langs: StringResource by lazy {
      StringResource("string:home_cd_switch_langs", "home_cd_switch_langs", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2006, 52),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2426, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1999, 52),
      ))
    }

@delegate:ResourceContentHash(-969_661_639)
public val Res.string.home_input_hint: StringResource by lazy {
      StringResource("string:home_input_hint", "home_input_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2059, 39),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2487, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2052, 39),
      ))
    }

@delegate:ResourceContentHash(-594_141_886)
public val Res.string.home_search_for_raw_input: StringResource by lazy {
      StringResource("string:home_search_for_raw_input", "home_search_for_raw_input", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2099, 65),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2555, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2092, 61),
      ))
    }

@delegate:ResourceContentHash(-1_162_449_884)
public val Res.string.search_results_cd_pause: StringResource by lazy {
      StringResource("string:search_results_cd_pause", "search_results_cd_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2165, 59),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2617, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2154, 71),
      ))
    }

@delegate:ResourceContentHash(-2_073_964_365)
public val Res.string.search_results_cd_play: StringResource by lazy {
      StringResource("string:search_results_cd_play", "search_results_cd_play", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2225, 58),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2725, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2226, 70),
      ))
    }

@delegate:ResourceContentHash(148_588_488)
public val Res.string.search_results_download_langs_dialog_text: StringResource by lazy {
      StringResource("string:search_results_download_langs_dialog_text", "search_results_download_langs_dialog_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2284, 169),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2828, 221),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2297, 153),
      ))
    }

@delegate:ResourceContentHash(1_916_154_475)
public val Res.string.search_results_download_langs_dialog_title: StringResource by lazy {
      StringResource("string:search_results_download_langs_dialog_title", "search_results_download_langs_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2454, 86),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3050, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2451, 86),
      ))
    }

@delegate:ResourceContentHash(-480_310_776)
public val Res.string.search_results_hide_extra_details: StringResource by lazy {
      StringResource("string:search_results_hide_extra_details", "search_results_hide_extra_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2541, 85),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3161, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2538, 65),
      ))
    }

@delegate:ResourceContentHash(-1_675_628_542)
public val Res.string.search_results_pronounciation_title: StringResource by lazy {
      StringResource("string:search_results_pronounciation_title", "search_results_pronounciation_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2627, 71),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3275, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2604, 75),
      ))
    }

@delegate:ResourceContentHash(-1_828_634_794)
public val Res.string.search_results_show_extra_details: StringResource by lazy {
      StringResource("string:search_results_show_extra_details", "search_results_show_extra_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2699, 81),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3371, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2680, 65),
      ))
    }

@delegate:ResourceContentHash(-217_618_069)
public val Res.string.search_results_title: StringResource by lazy {
      StringResource("string:search_results_title", "search_results_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2781, 36),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3493, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2746, 40),
      ))
    }

@delegate:ResourceContentHash(-271_941_542)
public val Res.string.settings_data_sources_title: StringResource by lazy {
      StringResource("string:settings_data_sources_title", "settings_data_sources_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2818, 67),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3538, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2787, 63),
      ))
    }

@delegate:ResourceContentHash(-1_424_056_995)
public val Res.string.settings_lexical_items_details_types_title: StringResource by lazy {
      StringResource("string:settings_lexical_items_details_types_title", "settings_lexical_items_details_types_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2886, 102),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3646, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2851, 90),
      ))
    }

@delegate:ResourceContentHash(-755_320_836)
public val Res.string.settings_privacy_policy: StringResource by lazy {
      StringResource("string:settings_privacy_policy", "settings_privacy_policy", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2989, 59),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3789, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2942, 51),
      ))
    }

@delegate:ResourceContentHash(-2_116_370_657)
public val Res.string.settings_title: StringResource by lazy {
      StringResource("string:settings_title", "settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3049, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3893, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2994, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("general_action_cancel", Res.string.general_action_cancel)
  map.put("general_action_collapse", Res.string.general_action_collapse)
  map.put("general_action_copy", Res.string.general_action_copy)
  map.put("general_action_download", Res.string.general_action_download)
  map.put("general_action_expand", Res.string.general_action_expand)
  map.put("general_action_search", Res.string.general_action_search)
  map.put("general_cd_translate", Res.string.general_cd_translate)
  map.put("general_copied_to_clipboard", Res.string.general_copied_to_clipboard)
  map.put("general_data_source_chatgpt", Res.string.general_data_source_chatgpt)
  map.put("general_data_source_deepl", Res.string.general_data_source_deepl)
  map.put("general_data_source_kaikki", Res.string.general_data_source_kaikki)
  map.put("general_data_source_mlkit", Res.string.general_data_source_mlkit)
  map.put("general_data_source_panlex", Res.string.general_data_source_panlex)
  map.put("general_data_source_tatoeba", Res.string.general_data_source_tatoeba)
  map.put("general_data_source_wortschatz_leipzig", Res.string.general_data_source_wortschatz_leipzig)
  map.put("general_data_source_youglish", Res.string.general_data_source_youglish)
  map.put("general_lang_de", Res.string.general_lang_de)
  map.put("general_lang_en", Res.string.general_lang_en)
  map.put("general_lang_fr", Res.string.general_lang_fr)
  map.put("general_lang_ru", Res.string.general_lang_ru)
  map.put("general_lexical_item_detail_type_etymology", Res.string.general_lexical_item_detail_type_etymology)
  map.put("general_lexical_item_detail_type_example", Res.string.general_lexical_item_detail_type_example)
  map.put("general_lexical_item_detail_type_explanation", Res.string.general_lexical_item_detail_type_explanation)
  map.put("general_lexical_item_detail_type_forms", Res.string.general_lexical_item_detail_type_forms)
  map.put("general_lexical_item_detail_type_pronunciation", Res.string.general_lexical_item_detail_type_pronunciation)
  map.put("general_lexical_item_detail_type_synonyms", Res.string.general_lexical_item_detail_type_synonyms)
  map.put("general_lexical_item_detail_type_word_translations", Res.string.general_lexical_item_detail_type_word_translations)
  map.put("general_pos_adj", Res.string.general_pos_adj)
  map.put("general_pos_adv", Res.string.general_pos_adv)
  map.put("general_pos_article", Res.string.general_pos_article)
  map.put("general_pos_conj", Res.string.general_pos_conj)
  map.put("general_pos_det", Res.string.general_pos_det)
  map.put("general_pos_inj", Res.string.general_pos_inj)
  map.put("general_pos_noun", Res.string.general_pos_noun)
  map.put("general_pos_num", Res.string.general_pos_num)
  map.put("general_pos_particle", Res.string.general_pos_particle)
  map.put("general_pos_prep", Res.string.general_pos_prep)
  map.put("general_pos_pron", Res.string.general_pos_pron)
  map.put("general_pos_verb", Res.string.general_pos_verb)
  map.put("general_translated_by_postfix", Res.string.general_translated_by_postfix)
  map.put("home_btn_search", Res.string.home_btn_search)
  map.put("home_cd_clear_search_query", Res.string.home_cd_clear_search_query)
  map.put("home_cd_settings", Res.string.home_cd_settings)
  map.put("home_cd_switch_langs", Res.string.home_cd_switch_langs)
  map.put("home_input_hint", Res.string.home_input_hint)
  map.put("home_search_for_raw_input", Res.string.home_search_for_raw_input)
  map.put("search_results_cd_pause", Res.string.search_results_cd_pause)
  map.put("search_results_cd_play", Res.string.search_results_cd_play)
  map.put("search_results_download_langs_dialog_text", Res.string.search_results_download_langs_dialog_text)
  map.put("search_results_download_langs_dialog_title", Res.string.search_results_download_langs_dialog_title)
  map.put("search_results_hide_extra_details", Res.string.search_results_hide_extra_details)
  map.put("search_results_pronounciation_title", Res.string.search_results_pronounciation_title)
  map.put("search_results_show_extra_details", Res.string.search_results_show_extra_details)
  map.put("search_results_title", Res.string.search_results_title)
  map.put("settings_data_sources_title", Res.string.settings_data_sources_title)
  map.put("settings_lexical_items_details_types_title", Res.string.settings_lexical_items_details_types_title)
  map.put("settings_privacy_policy", Res.string.settings_privacy_policy)
  map.put("settings_title", Res.string.settings_title)
}
